import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const BusinessTaskStore = {
  namespaced: true,
  state: {
    businessesMonthlyStatesTask: [],
    lastLocalUpdate: null,
    pendingUpdates: 0
  },
  getters,
  mutations,
  actions
}

export default BusinessTaskStore